import { Button, Modal, Select, Stack, Textarea } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import {
  CONTACT_CHANNEL_OPTIONS,
  CONTACT_OUTCOME_OPTIONS,
  LOG_CONTACT_ACTION,
  LOG_CONTACT_TITLE,
} from "../../constants/matching";
import { candidatesApi } from "../../lib/api";
import { ApiError } from "../../lib/apiClient";
import { trackEvent } from "../../lib/observability";

const LOG_FAILED_TITLE = "Could not log contact";
const LOG_OK_TITLE = "Contact logged";
const CHANNEL_LABEL = "Channel";
const OUTCOME_LABEL = "Outcome";
const NOTE_LABEL = "Note (optional)";
const LOG_OK_MESSAGE = "Saved to this candidate.";
const CHANNEL_SELECT_DATA = [...CONTACT_CHANNEL_OPTIONS];
const OUTCOME_SELECT_DATA = [...CONTACT_OUTCOME_OPTIONS];

export function LogContactModal({
  opened,
  onClose,
  candidateId,
  jobId,
  defaultChannel,
}: {
  opened: boolean;
  onClose: () => void;
  candidateId: string;
  jobId?: string | null;
  defaultChannel?: string | null;
}) {
  const [channel, setChannel] = useState<string | null>(defaultChannel ?? CONTACT_CHANNEL_OPTIONS[0].value);
  const [outcome, setOutcome] = useState<string | null>(null);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    if (!channel || !outcome) return;
    setSaving(true);
    try {
      await candidatesApi.logContact(candidateId, {
        job_id: jobId || undefined,
        channel,
        outcome,
        note: note.trim() || undefined,
      });
      trackEvent("outreach.contact_logged", { channel, outcome });
      notifications.show({ color: "green", title: LOG_OK_TITLE, message: LOG_OK_MESSAGE });
      setOutcome(null);
      setNote("");
      onClose();
    } catch (err) {
      notifications.show({
        color: "red",
        title: LOG_FAILED_TITLE,
        message: err instanceof ApiError ? err.message : LOG_FAILED_TITLE,
      });
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal opened={opened} onClose={onClose} title={LOG_CONTACT_TITLE} centered>
      <Stack>
        <Select
          label={CHANNEL_LABEL}
          data={CHANNEL_SELECT_DATA}
          value={channel}
          allowDeselect={false}
          onChange={(value) => {
            if (value) setChannel(value);
          }}
        />
        <Select
          label={OUTCOME_LABEL}
          data={OUTCOME_SELECT_DATA}
          value={outcome}
          allowDeselect={false}
          onChange={setOutcome}
        />
        <Textarea label={NOTE_LABEL} value={note} onChange={(event) => setNote(event.currentTarget.value)} minRows={2} />
        <Button onClick={() => void handleSave()} loading={saving} disabled={!channel || !outcome}>
          {LOG_CONTACT_ACTION}
        </Button>
      </Stack>
    </Modal>
  );
}
